'use strict';

module.exports = {
    getUrl: Odigeo._.constant(Odigeo.Settings.getProperty('membershipServiceFormatter')('createpostbookingmember')),

    getMethod: Odigeo._.constant('POST'),

    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:createPostBookingMemberOk`, data);
    },

    requestError() {
        Odigeo.trigger(`${this.widget.id}:createPostBookingMemberFail`);
    },

    formatData(request) {
        return JSON.stringify({
            userId: request.userId,
            email: request.email,
            name: request.name,
            lastNames: request.lastNames,
            webSite: request.webSite,
            monthsToRenewal: request.monthsToRenewal,
            membershipType: request.membershipType,
            balance: request.balance,
            channel: request.channel,
        });
    },
};
